import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaExternalLinkAlt } from "react-icons/fa"; // Import "Open Web" icon
import "./SportPsychologyTrainingsListing.css";
import WebViewCard from "../../components/commonComponent/WebViewCard";

const API_URL = process.env.REACT_APP_API_URL;

const SportPsychologyTrainingView = () => {
  const [sports, setSports] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSport = async () => {
      const response = await fetch(`${API_URL}/getAllSportPsychologyTraining`);
      const data = await response.json();
      console.log(data, "Fetched Sport Psychology Training");

      setSports(data?.data || []);
    };

    fetchSport();
  }, []);
  console.log(sports);
  return (
    <div className="blog-listing">
      <div className="blog-container grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {sports.length > 0 ? (
          sports.map((sport) => (
            <WebViewCard  key={sport.id} title={sport.title} path={sport.link} newWindow={true} />
          ))
        ) : (
          <p className="text-gray-600 text-center">
            Loading Sport Psychology Training...
          </p>
        )}
      </div>
    </div>
  );
};

export default SportPsychologyTrainingView;
